import { TemplateResult } from 'lit';
import { LitComponent } from './LitComponent.ts';
import { shellFormDataForm, type ShellFormDataField } from '@src/modules/shell-ui/infrastructure/shellFormFieldsUi.ts';

export type FormFieldProps = ShellFormDataField;

export class FormComponent extends LitComponent {
  private fields: FormFieldProps[] = [];
  private submitLabel: string = 'Submit';
  private submitButtonClass: string = 'md-btn-filled md-sys-ripple w-full';
  private submitBusy = false;
  private onSubmitCallback?: (formData: FormData) => void | Promise<void>;

  setProps(props: {
    fields: FormFieldProps[];
    submitLabel: string;
    onSubmit: (formData: FormData) => void | Promise<void>;
    submitButtonClass?: string;
    submitBusy?: boolean;
  }): void {
    this.fields = props.fields;
    this.submitLabel = props.submitLabel;
    this.onSubmitCallback = props.onSubmit;
    this.submitBusy = Boolean(props.submitBusy);
    if (props.submitButtonClass) {
      this.submitButtonClass = props.submitButtonClass;
    }
    this.update();
  }

  protected getTemplate(): TemplateResult {
    return shellFormDataForm({
      fields: this.fields,
      submitLabel: this.submitLabel,
      submitBusy: this.submitBusy,
      submitButtonClass: this.submitButtonClass,
      onSubmit: (formData) => this.onSubmitCallback?.(formData) ?? undefined,
    });
  }
}

customElements.define('form-component', FormComponent);
